const dataLayer = window.dataLayer || [];

export default class TrackingStateService {
  trackStateChange(fromState, toState) {
    dataLayer.push({
      event: "ngStateChange",
      attributes: { fromState, toState },
    });
  }

  trackCustomEvent(customEventId) {
    if (customEventId.includes("package_branding")) {
      if (customEventId.includes("hired")) {
        customEventId = "package-branding-hired";
      } else if (customEventId.includes("cancel")) {
        customEventId = "package-branding-cancel";
      }
    }

    dataLayer.push({
      event: customEventId,
    });
  }
}
